import { Wrap, H2, SwitchContainer, SwitchLabel, Switch } from './styles';

import AppLogo from './appLogo';
import CarPartsBackground from './CarPartsBackground';

import React, { useState } from 'react';
import ScrollableAnchor from 'react-scrollable-anchor';

export default props => {
  const [isClicker, setIsClicker] = useState(false);

  const links = {
    client: {
      android: 'https://link.orango.io/AjRVc',
      ios: 'https://link.orango.io/VAkea',
    },
    clicker: {
      android: 'https://link.orango.io/laEMV',
      ios: 'https://link.orango.io/8Rjmz',
    },
  };

  const currentLinks = isClicker ? links.clicker : links.client;

  return (
    <ScrollableAnchor id="app">
      <Wrap isClicker={isClicker}>
        <CarPartsBackground />
        <div className="container">
          <div>
            <AppLogo />
            <H2 isClicker={isClicker}>BAIXE NOSSO APP</H2>

            <SwitchContainer>
              <SwitchLabel
                active={!isClicker}
                isClicker={isClicker}
                onClick={() => setIsClicker(false)}
              >
                Cliente
              </SwitchLabel>
              <Switch
                isClicker={isClicker}
                onClick={() => setIsClicker(!isClicker)}
              />
              <SwitchLabel
                active={isClicker}
                isClicker={isClicker}
                onClick={() => setIsClicker(true)}
              >
                Clicker
              </SwitchLabel>
            </SwitchContainer>

            <div>
              <p>
                Nosso aplicativo chegou! E com ele mais praticidade, baixe agora
                e mude sua forma de lavar o carro: com um click!
              </p>
              <div>
                <a
                  href={currentLinks.android}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button>
                    <img
                      alt="Disponível no Google Play Store"
                      src="/img/google-play-badge.png"
                    ></img>
                  </button>
                </a>
                <a
                  href={currentLinks.ios}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button>
                    <img
                      alt="Disponível na Apple Store"
                      src="/img/download-on-the-app-store.svg"
                    />
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </Wrap>
    </ScrollableAnchor>
  );
};
